export const CREATE_USER = "CREATE_USER";
export const UPDATE_USER = "UPDATE_USER";
export const DELETE_USER = "DELETE_USER";
export const FETCH_USERS = "FETCH_USERS";
export const LISTEN_TO_SELECTED_USER = "LISTEN_TO_SELECTED_USER";
